export const formatDurationAsString = (duration: number) => {
  return duration >= 60
    ? `${Math.floor(duration / 60)}hr, ${duration % 60} min`
    : `${duration} min`;
};
